import React, { useEffect } from 'react';
import './product.css';
import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product5 from '../assets/product5.png';
import product4 from '../assets/product4.png';
// import whatsappIcon from '../assets/whatsapp.png';
import Features from './Features';
import { Link } from 'react-router-dom';

// Import Bootstrap JS for tooltips
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Contact from './Contact';
import Review from './Reviews';
import Reviews from './Reviews';
import Productsdiv3 from './Productsdiv3';
import HomeContact from './HomeContact';

const ProductCard = ({ heading, description, image, buttonText, isEven }) => {
  return (
    <div className="row align-items-center my-5">
      <div className={`col-md-6 ${isEven ? 'order-md-1' : 'order-md-2'} text-center`}>
        <img src={image} alt={heading} className="img-fluid" style={{ maxHeight: '400px' }} />
      </div>
       
      <div className={`col-md-6 ${isEven ? 'order-md-2 text-start' : 'order-md-1 text-start'} px-5`}>
        <h2 className="fw-bold mb-4">{heading}</h2>
        <p className="text-secondary mb-4 fs-5" style={{ lineHeight: '1.8' }}>{description}</p>
       <Link to={buttonText}><button className="btn btn-info px-4 py-2 text-white fw-semibold">Click Here</button></Link> 
      </div>
    </div>
  );
};

const Product = () => {
  // 🔧 Tooltip activation using useEffect
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const products = [
     {
      heading: 'WARALS SCHOOL MANAGEMENT SYSTEM',
      description:
        'WARALS School management system controls the complete Business Cycle of your School. Its detailed and informative dashboard with powerful reporting modules optimizes operational efficiency. This one-stop solution manages the entire school functions efficiently to increase the Quality of Education, Parents Satisfaction and Profitability.',
      image: product5,
      buttonText: '/warals-school-management-system',
    },
    {
      heading: 'WARALS INSTITUTE MANAGEMENT SYSTEM',
      description:
        'WARALS IMS reduces the operational complexity of academic institutes. It helps institutes achieve the core goal and maximize revenue generation. As a specialized product and a result of collaborative efforts by our architects, WARALS institute management software manages vital academic records and enhances administrative synchronization.',
      image: product1,
      buttonText: '/warals-institute-management-system',
    },
    {
      heading: 'WARALS LEARNING MANAGEMENT SYSTEM',
      description:
        'WARALS LMS is a powerful Learning Management System for schools and institutes, designed to revolutionize the E-Learning system. Its salient features consist of conducting Live Online classes with the option of Online Quizzes. It comes with each essential tool to meet your all E-Learning needs and provides flexibility for all requirements.',
      image: product2,
      buttonText: '/warals-learning-management-system',
    },
    {
      heading: 'WEBSITE DEVELOPMENT COMPANY',
      description:
        'Our Website Development services are tailored to bring your vision to life. From dynamic business websites to e-commerce platforms and custom portals, we craft responsive, fast, and secure websites that engage users and elevate your digital presence. With a blend of modern design, intuitive user experience (UX), and powerful backend technology, we ensure your online platform not only looks great but performs flawlessly. Whether you are a startup or an established enterprise, our end-to-end development solutions help you thrive in the digital world.',
      image: product4,
      buttonText: '/warals-website-develop',
    },
  ];

  return (
    <>
      <div id='products' className="py-5 mb-5" style={{ backgroundColor: '#f8f9fa', scrollMarginTop: '80px' }}>
        <div className="container-lg text-center">
          <h3 className="fw-bold mb-4 pd-3">
            OUR <span className="partial-border">PRODU</span>CTS
          </h3>
          <p
            className="fw-bold text-secondary"
            style={{ maxWidth: '900px', margin: '0 auto', lineHeight: '1.8' }}
          >
            WARALS Technology has an extensive range of Industry Specific Management Software Products.
            These products are a comprehensive blend of CRM and Accounting modules which provide an
            absolute solution for managing all essential Business Functions in one place.
            <br /><br />
            Our school management software efficiently organizes customized databases such as scheduling
            online classes with quizzes and managing inquiries, admission, batches, fees, etc. All
            user-friendly modules streamline the entire administration, provide insights into the overall
            management status, help prioritize business needs, boost sales, and drive business growth.
          </p>

          <div id='servicesf' className="mt-5" style={{scrollMarginTop:'80px'}}>
            {products.map((product, index) => (
              <ProductCard
                key={index}
                heading={product.heading}
                description={product.description}
                image={product.image}
                buttonText={product.buttonText}
                isEven={index % 2 !== 0}
              />
            ))}
          </div>
        </div>
      </div>

    <HomeContact smallHeading="A Complete Solution For Your Education Business" largeHeading="Enhance The Entire Administration, Boost Operational Efficiency And Drive Sales" />
    {/* lightHeading="Efficiently organize and conduct live online classes with exams remotely" */}

      <Features />
      <Reviews/>
     
      <Contact/>
    </>
  );
};

export default Product;
